import { MprcJoinComponents } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { KnowledgeUserMixPublicationSource } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { CardChannelLink } from "views/knowledge/components/card/behaviors/common/CardChannelLink";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { DefaultClassification } from "../common/DefaultClassification";

///
export const FeedStartupClassification = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");

    const classification = pub.publicationSource == KnowledgeUserMixPublicationSource.InHigh
        ? t("Feed.Card.Common.InHighText")
        : pub.publicationSource == KnowledgeUserMixPublicationSource.RecommendedIA
            ? t("Feed.Card.Common.RecommendedText")
            : pub.publicationSource == KnowledgeUserMixPublicationSource.DirectQuestion
                ? t("Feed.Card.Common.DirectQuestionText")
                : pub.publicationSource == KnowledgeUserMixPublicationSource.QuestionIA
                    ? t("Feed.Card.Common.QuestionIAText")
                    : null;

    const components: React.ReactNode[] = [];

    if (pub.interaction.reclassified)
        components.push(<MprcFeedTypography variant="classification" component="span" color="error">{t("Feed.Card.Common.ReclassifiedText")}</MprcFeedTypography>);
    else if (classification)
        components.push(<MprcFeedTypography variant="classification">{classification}</MprcFeedTypography>);

    if (components.length > 0 && pub.channel?.name)
        components.push(<MprcFeedTypography variant="classification"><CardChannelLink /></MprcFeedTypography>);

    return components.length > 0
        ? <MprcFeedTypography variant="classification" noWrap component="div"><MprcJoinComponents separator="&bull;" components={components} /></MprcFeedTypography>
        : <DefaultClassification />;
};
